class MC_VideoPopup {
    constructor() {
        this.initVideo();
    }
    initVideo() {
        var openPopups = $('.open-video-popup');

        if (!openPopups.length) {
            return;
        }

        for (var i = 0; i < openPopups.length; i++) {
            var overlay = openPopups.eq(i);

            openPopups.eq(i).on('click', function (e) {
                e.preventDefault();
                var stat_url = $(e.target).parent().attr('data-id');
                var dataSrc = $(e.target).parents('.course-item').find('img').attr('data-src');
                var videoPopup = $('#main').find('.video-popup');
                var closePopup = videoPopup.find('.close-video-popup');
                var videoPopupText = videoPopup.find('.text');
                var iframe = $('#main').find('#video-popup-iframe');
                videoPopup.addClass('is-open');

                iframe.on('load', function () {
                    setTimeout(() => {
                        if (iframe.hasClass('video')) {
                            iframe[0].contentWindow.postMessage(JSON.stringify({
                                'event': 'command',
                                'func': 'playVideo',
                                'args': []
                            }), '*');
                        } else {
                            iframe[0].contentWindow.postMessage('{ "method": "play" }', '*');
                        }
                    }, 500);
                });

                closePopup.on('click', function() {
                    videoPopup.removeClass('is-open');
                    videoPopupText.html('');
                    if (iframe.hasClass('video')) {
                        iframe[0].contentWindow.postMessage(JSON.stringify({
                            'event': 'command',
                            'func': 'pauseVideo',
                            'args': []
                        }), '*');
                    } else {
                        iframe[0].contentWindow.postMessage('{ "method": "pause" }', '*');
                    }
                });

                $(document).keyup(function(e) {
                    if (e.key === "Escape") { // escape key maps to keycode `27`
                        videoPopup.removeClass('is-open');
                        videoPopupText.html('');

                        if (iframe.hasClass('video')) {
                            iframe[0].contentWindow.postMessage(JSON.stringify({
                                'event': 'command',
                                'func': 'playVideo',
                                'args': []
                            }), '*');
                        } else {
                            iframe[0].contentWindow.postMessage('{ "method": "pause" }', '*');
                        }
                    }
                });

                iframe.attr('src', dataSrc + '?enablejsapi=1');

                if(stat_url != undefined && stat_url.length > 10){
                    $.ajax({
                        url: stat_url,
                        type: 'POST',
                        dataType: 'json'
                    });
                }
            });
        }
    }
}
